import { render, staticRenderFns } from "./PersonalHistoryForm.vue?vue&type=template&id=20800d6d&scoped=true&"
import script from "./PersonalHistoryForm.vue?vue&type=script&lang=js&"
export * from "./PersonalHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalHistoryForm.vue?vue&type=style&index=0&id=20800d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20800d6d",
  null
  
)

export default component.exports